var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ob-admin-section',{attrs:{"type":"access","xlsx":false,"add":false,"edit":false,"confirm-value":_vm.confirm.dialog},on:{"confirmed":_vm._cbConfirmed}},[_c('template',{slot:"section-title"},[_vm._v("Sectiune Acces Applicatie")]),_c('template',{slot:"toolbar-title"},[_vm._v("Baza de date Acces Applicatie")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }